<template>
    <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
    </div>
    <div v-else>
        <v-row>
            <v-col xs="12" sm="12" md="8" lg="10" xl="10" cols="12">
                <div class="title_page ma-3">
                    <h4 class="breadcrumb_title_page">แก้ไขซัพพลายเออร์</h4>
                    <v-breadcrumbs :items="sub_menu">
                        <template v-slot:divider>
                            <v-icon>mdi-chevron-right</v-icon>
                        </template>
                    </v-breadcrumbs>
                </div>
            </v-col>
            <v-col xs="12" sm="12" md="4" lg="2" xl="2" cols="12">
                <div class="title_page ma-3">
                    <v-btn type="button" class="btn_back_page" elevation="4" @click="$router.back()" large>ย้อนกลับ</v-btn>
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                <v-card>
                    <v-card-text>
                        <v-form ref="form" @submit.prevent="editSupplier">
                            <v-row>
                                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                                    <v-form-group>
                                        <v-radio-group v-model="list_value.supplier_type" row>
                                            <v-radio label="บุคคลธรรมดา" color="#D6BFAF" :value="1"></v-radio>
                                            <v-radio label="นิติบุคคล" color="#D6BFAF" :value="2"></v-radio>
                                        </v-radio-group>
                                    </v-form-group>
                                </v-col>
                            </v-row>
                            <v-row>
                                <!-- ข้อมูลซัพพลายเออร์ -->
                                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                                    <div class="d-flex">
                                        <div class="title_form_main">
                                            <div class="logo_timeline">
                                                <img src="@/assets/arin_assets/company.png">
                                            </div>
                                        </div>
                                        <div class="header-content py-1 pl-5 pr-5 text-center">
                                            <div class="content-font">ข้อมูลซัพพลายเออร์</div>
                                        </div>
                                    </div>
                                </v-col>
                            </v-row>
                            <v-row style="padding-left: 50px;">
                                <v-col xs="12" sm="12" md="6" lg="6" xl="6" cols="12">
                                    <v-form-group>
                                        <label class="label_form_text">ชื่อแผนก</label>
                                        <v-text-field color="#D6BFAF" class="input-radius" v-model="list_value.department"
                                            prepend-inner-icon="mdi-card-account-details" hide-details="auto"
                                            placeholder="กรุณากรอกชื่อแผนก"
                                            single-line outlined dense ></v-text-field>
                                    </v-form-group>
                                </v-col>
                                <v-col xs="12" sm="12" md="6" lg="6" xl="6" cols="12">
                                    <v-form-group>
                                        <label class="label_form_text">อีเมล</label>
                                        <v-text-field color="#D6BFAF" class="input-radius" prepend-inner-icon="mdi-email"
                                            v-model="list_value.email" @keypress="isEmail($event, email)" hide-details="auto"
                                            placeholder="กรุณากรอกอีเมล" single-line
                                            outlined dense ></v-text-field>
                                    </v-form-group>
                                </v-col>
                                <v-col xs="12" sm="12" md="6" lg="6" xl="6" cols="12">
                                    <v-form-group>
                                        <label class="label_form_text">ชื่อ (ไทย)</label>
                                        <v-text-field color="#D6BFAF" class="input-radius" prepend-inner-icon="mdi-account"
                                            v-model="list_value.name" hide-details="auto" :rules="[v => !!v || 'กรุณากรอกชื่อ (ไทย)']"
                                            placeholder="กรุณากรอกชื่อ (ไทย)" single-line outlined dense
                                            required></v-text-field>
                                    </v-form-group>
                                </v-col>
                                <v-col xs="12" sm="12" md="6" lg="6" xl="6" cols="12">
                                    <v-form-group>
                                        <label class="label_form_text">ชื่อ (อังกฤษ)</label>
                                        <v-text-field color="#D6BFAF" class="input-radius" prepend-inner-icon="mdi-account"
                                            v-model="list_value.name_eng" hide-details="auto"
                                            placeholder="กรุณากรอกชื่อ (อังกฤษ)"
                                            single-line outlined dense ></v-text-field>
                                    </v-form-group>
                                </v-col>
                                <v-col xs="12" sm="12" md="6" lg="6" xl="6" cols="12">
                                    <v-form-group>
                                        <label class="label_form_text">ชื่อย่อ</label>
                                        <v-text-field color="#D6BFAF" class="input-radius" prepend-inner-icon="mdi-account"
                                            v-model="list_value.short_name" hide-details="auto"
                                            placeholder="กรุณากรอกชื่อย่อ" single-line outlined dense ></v-text-field>
                                    </v-form-group>
                                </v-col>
                                <v-col xs="12" sm="12" md="6" lg="6" xl="6" cols="12">
                                    <v-form-group>
                                        <label class="label_form_text">เลขเสียภาษี</label>
                                        <v-text-field color="#D6BFAF" class="input-radius"
                                            prepend-inner-icon="mdi-card-account-details" @keypress="isTaxNumber($event, list_value.tax_number)" v-model="list_value.tax_number" hide-details="auto"
                                            length="13" type="number" 
                                            placeholder="กรุณากรอกเลขเสียภาษี" single-line outlined dense
                                            required></v-text-field>
                                    </v-form-group>
                                </v-col>
                            </v-row>
                            <v-row>
                                <!-- ที่อยู่ -->
                                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                                    <div class="d-flex">
                                        <div class="title_form_main">
                                            <div class="logo_timeline">
                                                <img src="@/assets/arin_assets/pin.png">
                                            </div>
                                        </div>
                                        <div class="header-content py-1 pl-5 pr-5 text-center">
                                            <div class="content-font">ที่อยู่</div>
                                        </div>
                                    </div>
                                </v-col>
                            </v-row>
                            <v-row style="padding-left: 50px;">
                                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                                    <v-form-group>
                                        <label class="label_form_text">ที่อยู่</label>
                                        <v-text-field color="#D6BFAF" class="input-radius" prepend-inner-icon="mdi-home"
                                            hide-details="auto" v-model="list_value.address" placeholder="กรุณากรอกที่อยู่" single-line
                                            outlined dense required></v-text-field>
                                    </v-form-group>
                                </v-col>

                                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                                    <v-form-group>
                                        <label class="label_form_text">ตำบล/อำเภอ/จังหวัด/รหัสไปรษณีย์</label>
                                        <v-autocomplete color="#D6BFAF" class="input-radius" hide-details="auto"
                                            :items="addressList" item-text="name" item-value="name" v-model="list_value.sub_district"
                                            placeholder="ตำบล /อำเภอ /จังหวัด /รหัสไปรษณีย์ " single-line outlined
                                            dense></v-autocomplete>
                                    </v-form-group>
                                </v-col>
                            </v-row>
                            <v-row>
                                <!-- ติดต่อ -->
                                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                                    <div class="d-flex">
                                        <div class="title_form_main">
                                            <div class="logo_timeline">
                                                <img src="@/assets/arin_assets/pin.png">
                                            </div>
                                        </div>
                                        <div class="header-content py-1 pl-5 pr-5 text-center">
                                            <div class="content-font">ข้อมูลผู้ติดต่อ</div>
                                        </div>
                                    </div>
                                </v-col>
                            </v-row>
                            <v-row style="padding-left: 50px;">
                                <v-col xs="12" sm="12" md="6" lg="6" xl="6" cols="12">
                                    <v-form-group>
                                        <label class="label_form_text">ชื่อ-นามสกุล</label>
                                        <v-text-field color="#D6BFAF" class="input-radius" prepend-inner-icon="mdi-account"
                                            v-model="list_value.name_contact" hide-details="auto"
                                            placeholder="กรุณากรอกชื่อ-นามสกุล"
                                            single-line outlined dense required></v-text-field>
                                    </v-form-group>
                                </v-col>
                                <v-col xs="12" sm="12" md="6" lg="6" xl="6" cols="12">
                                    <v-form-group>
                                        <label class="label_form_text">เบอร์โทร</label>
                                        <v-text-field color="#D6BFAF" class="input-radius" prepend-inner-icon="mdi-phone"
                                            v-model="list_value.telephone_contact" hide-details="auto" @keypress="isNumber($event, list_value.telephone_contact)"
                                            @paste="isPaste($event)" 
                                            placeholder="กรุณากรอกเบอร์โทร" single-line outlined dense required></v-text-field>
                                    </v-form-group>
                                </v-col>
                                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                                    <div class="title_page ma-3" style="justify-content:center;">
                                        <v-btn type="submit" class="btn_add_data_sutmit" elevation="4" large>บันทึก</v-btn>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>
<script>

import { HTTP_ARIN } from "@/axios_arin";
import { isTelephone, taxNumber, validateEmail, onPaste, onlyForCurrency } from "@/js/handler";
import Swal from "sweetalert2";
export default {
    inject: {
        theme: {
            default: {
                isDark: false,
            },
        },
    },
    name: 'Pos_supplier_add',
    data() {
        return {
            loading_page: false,

            // ตัวแปร
            list_value:[],

            sub_menu: [
                {
                    text: 'ระบบ POS',
                    disabled: false,
                },
                {
                    text: 'ออกใบสั่งซื้อ',
                    disabled: false,
                },
                {
                    text: 'ซัพพลายเออร์​',
                    disabled: false,
                },
                {
                    text: 'แก้ไขซัพพลายเออร์',
                    disabled: false,
                    href: '#',
                },
            ],
            addressList: [],
        }
    },
    methods: {
        getAddress_api() {
            const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
            HTTP_ARIN.get('/stores/addresslist', config).then((res) => {
                if (res.data.successful === true) {
                    this.loading_page = false;
                    this.addressList = res.data.addressList;
                }
            })
        },

        getSupplier_detail() {
            const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
            HTTP_ARIN.get('/supplier/supplierdetail/'+this.$route.params.id, config).then((res) => {
                if (res.data.successful === true) {
                    this.loading_page = false;
                    this.list_value = res.data.supplierDetail;
                }
            })
        },

        editSupplier() {
            let config = {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": `Bearer ${this.$store.state.store_arin.access_token}`
                }
            };
            if (this.$refs.form.validate()) {
                let data = {
                    supplier_type: this.list_value.supplier_type,
                    department: this.list_value.department,
                    short_name: this.list_value.short_name,
                    name: this.list_value.name,
                    name_eng: this.list_value.name_eng,
                    tax_number: this.list_value.tax_number,
                    address: this.list_value.address,
                    sub_district: this.list_value.sub_district,
                    email: this.list_value.email,
                    name_contact: this.list_value.name_contact,
                    telephone_contact: this.list_value.telephone_contact,
                }
                
                // ส่งไปเพิ่ม
                HTTP_ARIN.post('/supplier/editsupplier/'+this.$route.params.id, data, config)
                    .then((res) => {
                    if (res.data.successful === true) {
                        let timerInterval
                        Swal.fire({
                            title: 'เสร็จสิ้น',
                            text: 'แก้ไขข้อมูลเรียบร้อยแล้ว',
                            icon: 'success',
                            timer: 2000,
                            timerProgressBar: true,
                            didOpen: () => {
                                Swal.showLoading()
                                timerInterval = setInterval(() => { }, 100)
                            },
                            willClose: () => {
                                clearInterval(timerInterval)
                                setTimeout(function () {
                                    window.location.href = '/arin/pos/posSupplier';
                                });
                            }
                        })
                    } else {
                        Swal.fire({
                        title: 'ไม่สามารถดำเนินการได้ กรุณาลองใหม่อีกครั้ง!',
                        icon: 'error',
                        showDenyButton: false,
                        showCancelButton: false,
                        confirmButtonText: `ตกลง`,
                        denyButtonText: `ยกเลิก`,
                        })
                    }
                })
            }
        },
        link(link) {
            window.location.href = link;
        },
        isNumber: function (evt, number) {
            return isTelephone(evt, number)
        },
        isTaxNumber: function (evt, number) {
            return taxNumber(evt, number)
        },
        isEmail: function (evt) {
            return validateEmail(evt)
        },
        isPaste: function (evt) {
            return onPaste(evt)
        },
        isCurrency: function (evt, number) {
            return onlyForCurrency(evt, number)
        },
    },
    mounted() {
        this.getAddress_api()
        this.getSupplier_detail()
    }
}
</script>
<style>
label.label_form_text {
    font-size: 16px !important;
    color: #616A6B !important;
}

.input-radius {
    border-radius: 10px;
}

.btn_add_data_sutmit {
    font-size: 16px;
    color: #FFF !important;
    background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
    border-radius: 10px;
    width: 25% !important;
}

@media only screen and (min-width: 0px)AND (max-width: 361px) {
    .btn_add_data_sutmit {
        font-size: 16px;
        color: #FFF !important;
        background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
        border-radius: 10px;
        width: 100% !important;
    }
}

@media only screen and (max-width: 600px) {

    .title_page h4.breadcrumb_title_page,
    .v-tab {
        font-size: 14px !important;
    }

    .v-timeline-item__divider {
        display: none !important;
    }

    .btn_add_data_sutmit {
        font-size: 16px;
        color: #FFF !important;
        background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
        border-radius: 10px;
        width: 100% !important;
    }
}

@media only screen and (min-width: 601px) AND (max-width: 960px) {
    .btn_add_data_sutmit {
        font-size: 16px;
        color: #FFF !important;
        background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
        border-radius: 10px;
        width: 50% !important;
    }
}

@media only screen and (min-width: 961px) AND (max-width: 1264px) {
    .btn_add_data_sutmit {
        font-size: 16px;
        color: #FFF !important;
        background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
        border-radius: 10px;
        width: 25% !important;
    }
}

@media only screen and (min-width: 1265px) AND (max-width: 1904px) {
    .btn_add_data_sutmit {
        font-size: 16px;
        color: #FFF !important;
        background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
        border-radius: 10px;
        width: 25% !important;
    }
}
</style>